import { render, staticRenderFns } from "./ShopFooterLinks.vue?vue&type=template&id=ad01ac14&lang=pug&"
import script from "./ShopFooterLinks.vue?vue&type=script&lang=js&"
export * from "./ShopFooterLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports